export default __webpack_public_path__ + "cooling-tower.png?43bf7040cddcb4c8de506509768886b8";